import { combinedRoles } from "../constants";
import { PrimaryApplicantChangedActivity } from "../types";

export const PrimaryApplicantChanged = ({
  activityItem
}: {
  activityItem: PrimaryApplicantChangedActivity;
}) => {
  const { previous_primary, new_primary } = activityItem.details;
  const authorRole = activityItem.author?.author_role;

  return (
    <div className="space-y-2">
      <p className="text-base font-bold text-content-1000">
        Primary applicant updated{" "}
        <span className="font-normal">
          {activityItem.author?.name ? `by ${activityItem.author.name}` : ""}
          {authorRole ? ` (${combinedRoles[authorRole] || authorRole})` : ""}
        </span>
      </p>
      <p className="text-sm font-normal text-content-400">
        {previous_primary ? (
          <>
            Previous primary applicant {previous_primary.first_name}{" "}
            {previous_primary.last_name} →{" "}
          </>
        ) : null}
        New primary applicant {new_primary.first_name} {new_primary.last_name}
      </p>
    </div>
  );
};
